import {localize} from '@/utils/i18n'

export const formTextLocalize = {
    title: localize({
        ru: 'Оставить заявку',
        en: '',
        cn: ''
    }),
    type: localize({
        ru: 'Заявка',
        en: '',
        cn: ''
    }),
    group: {
        name: localize({
            ru: 'Название организации',
            en: '',
            cn: ''
        }),
        quantity: localize({
            ru: 'Общее количество участников экскурсии',
            en: '',
            cn: ''
        }),
        quantityDescription: localize({
            ru: 'Максимальное число участников одной экскурсии – 19 человек',
            en: '',
            cn: ''
        }),
    },
    special: {
        fio: localize({
            ru: 'ФИО',
            en: '',
            cn: ''
        }),
    },
    numberOfMinors: localize({
        ru: 'Количество несовершеннолетних участников (от 1 до 19)',
        en: '',
        cn: ''
    }),
    numberOfMinorsDescription: localize({
        ru: 'Несовершеннолетние участвуют в&nbsp;экскурсии только в&nbsp;сопровождении законных представителей. Согласно регламенту ООО &laquo;ИНК&raquo; РГ.02.31 &laquo;Организация и&nbsp;проведение экскурсий на&nbsp;промышленные объекты&raquo; лица, не&nbsp;достигшие возраста 18&nbsp;лет, к&nbsp;перевозке транспортом ООО &laquo;ИНК&raquo; и&nbsp;ООО &laquo;ИЗП&raquo; не&nbsp;допускаются.',
        en: '',
        cn: ''
    }),
    date: localize({
        ru: 'Желаемая дата экскурсии',
        en: '',
        cn: ''
    }),
    city: localize({
        ru: 'Город, из которого едет(ут) экскурсант(ы)',
        en: '',
        cn: ''
    }),
    cityDescription: localize({
        ru: 'Дорога до места старта – за счет участников экскурсии',
        en: '',
        cn: ''
    }),
    phone: localize({
        ru: 'Контактный телефон',
        en: '',
        cn: ''
    }),
    email: localize({
        ru: 'Контактный email',
        en: '',
        cn: ''
    }),
    personalDataAgree: localize({
        ru: 'Я&nbsp;даю согласие на&nbsp;обработку своих персональных данных. С&nbsp;Политикой ООО &laquo;ИНК&raquo; в&nbsp;области обработки <z-link href="/personal-data-policy/" target="_blank">персональных данных</z-link> и&nbsp;текстом согласия на&nbsp;обработку <z-link href="/personal-data-policy/" target="_blank">персональных данных</z-link> ознакомлен, возражений не&nbsp;имею.',
        en: '',
        cn: ''
    }),
    submit: localize({
        ru: 'Отправить',
        en: '',
        cn: ''
    }),
}
